import { useEffect, useState } from 'react';

/* Shared list pager — prev/next, a jump-to-page input, and "from–to of total".
   Renders nothing when everything fits on page 1. */
export function Pager({
  page,
  pageSize,
  total,
  onPage,
  loading = false,
}: {
  page: number;
  pageSize: number;
  total: number;
  onPage: (p: number) => void;
  loading?: boolean;
}) {
  const pages = Math.max(1, Math.ceil(total / pageSize));
  const [draft, setDraft] = useState(String(page));
  // Keep the input in sync when the page changes via prev/next or a reset.
  useEffect(() => {
    setDraft(String(page));
  }, [page]);

  if (total <= pageSize && page <= 1) return null;
  const from = total === 0 ? 0 : (page - 1) * pageSize + 1;
  const to = Math.min(total, page * pageSize);

  const go = () => {
    const n = Math.min(pages, Math.max(1, Math.floor(Number(draft) || 1)));
    setDraft(String(n));
    if (n !== page) onPage(n);
  };

  return (
    <div className="pager">
      <span className="muted">
        {from}–{to} of {total}
      </span>
      <div className="pager-btns">
        <button className="btn" disabled={loading || page <= 1} onClick={() => onPage(page - 1)}>
          Prev
        </button>
        <span className="pager-page">
          Page{' '}
          <input
            className="input pager-input"
            type="number"
            min={1}
            max={pages}
            value={draft}
            disabled={loading}
            aria-label="Go to page"
            onChange={(e) => setDraft(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') go();
            }}
            onBlur={go}
          />
          {' '}/ {pages}
        </span>
        <button className="btn" disabled={loading || page >= pages} onClick={() => onPage(page + 1)}>
          Next
        </button>
      </div>
    </div>
  );
}
